import React from "react";
import HeaderThree from "../common/header/HeaderThree";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import FeatureFive from "../components/features/FeatureFive";
import ProjectOne from "../components/project/ProjectOne";
import BrandOne from "../components/brand/BrandOne";
import FooterOne from "../common/footer/Footer";

const AboutOne = () => {
  return (
    <>
      <HeaderThree />
      <Breadcrumb heading="About Us" currentPage="About Us" />
      <FeatureFive />
      <ProjectOne />
      <BrandOne />
      <FooterOne />
    </>
  );
};

export default AboutOne;
